import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import { EmedUiSharedModule, HttpLoaderFactory } from '@multimediasrl/emed-ui-shared';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { ChartModule } from 'primeng/chart';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { PanelModule } from 'primeng/panel';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { TabsModule } from 'primeng/tabs';
import { DatePickerModule } from 'primeng/datepicker';
import { MenubarModule } from 'primeng/menubar';
import { DialogModule } from 'primeng/dialog';

import { environment } from '../../../environments/environment';

@NgModule({
  declarations: [],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    EmedUiSharedModule.forRoot({
      production: environment.production,
      baseUrl: environment.baseUrl,
      localStorageID: environment.localStorageID
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    TooltipModule,
    ChartModule,
    CardModule,
    FormsModule,
    MultiSelectModule,
    TableModule,
    PanelModule,
    AccordionModule,
    SelectModule,
    TabsModule,
    DatePickerModule,
    MenubarModule,
    DialogModule
  ],
  exports: [
    EmedUiSharedModule,
    ButtonModule,
    TooltipModule,
    ChartModule,
    CardModule,
    FormsModule,
    MultiSelectModule,
    TableModule,
    PanelModule,
    AccordionModule,
    SelectModule,
    TabsModule,
    DatePickerModule,
    MenubarModule,
    DialogModule
  ],
  providers: []
})
export class SharedModule {}
